import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import isTokenValid from "@/utils/validation/is-token-valid";
import { trackPageView } from "@/services/TrackingManagement";
import bypassMaintenanceMode from "@/router/utils/bypassMaintenanceMode";
import setRouteTitle from "@/router/utils/setRouteTitle";
import cancelPendingRequests from "@/router/utils/cancelPendingRequests";
import handleCacheKey from "@/router/utils/handleCacheKey";
import getDestination from "@/router/utils/getDestination";
import scrollTop from "@/router/utils/scrollTop";
import saveOriginalTargetDestination from "@/router/utils/saveOriginalTargetDestination";
import routes from "./routes/index"

/**
 * To solve the "NavigationDuplicated" error that happens
 * with .push() to navigate to the same route the user is already on.
 */
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
    .catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        throw err;
      }
      return err;
    });
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  bypassMaintenanceMode()

  setRouteTitle({ to });

  cancelPendingRequests({ from });

  if (to.name !== "login") saveOriginalTargetDestination({ to })

  const redirectTo = await getDestination({ to })

  scrollTop()

  if (redirectTo !== to.name) {
    return next({ name: redirectTo });
  }

  next();
});

router.afterEach(async (to) => {
  /**
   * @todo:: to be handled via middlewares later
   */
  if (!to.meta.bypassCacheKeyCheck) {
    await handleCacheKey()
  }

  store.dispatch("ResponseHandling/resetErrorsState")

  const tokenValid = isTokenValid();
  const isLoginAsActivated = store.getters["Authorization/isLoginAsActivated"]

  if (tokenValid && Object.keys(store.state.User.user).length && !isLoginAsActivated) {
    store.dispatch("Notifications/setUnseenNotificationCount")
  }

  if (store.getters["Authorization/isLoginAsActivated"] || !to.meta.entityName) return
  trackPageView({
    page_screen_name: to.meta.entityName,
    ...(Object.keys(store.state.User.user).length ? { ip_address: store.state.User.user.ipAddress } : {}),
  })
})

export default router;
